import { USER_ROLES } from 'app/models/user/user.constants';

const CLOSED = { canRead: false, canWrite: false, readOnly: true };
const OPEN = { canRead: true, canWrite: true, readOnly: false };

export function isEditorialResource(resource) {
  return ['program', 'content'].includes(resource?.type) && typeof resource.guid === 'string' && resource.guid.length > 0;
}

// Solo un R07 puede estar restringido: el resto de roles, y el R07 sin perfil activo, conservan su acceso
// sin depender de que /editorial-access/me responda ni de la revalidación por foco (TAN-10366: «las
// políticas no alteran R04 ni R07 sin perfil»).
export function getEditorialCapabilities(access, resources = []) {
  if (!access?.role) return CLOSED;
  if (access.role !== USER_ROLES.publisher) return OPEN;
  if (access.status !== 'ready' || !access.data) return CLOSED;
  if (access.data.restricted !== true) return OPEN;
  const writeReady = access.revalidating !== true && Array.isArray(resources) && !resources.some((resource) => resource?.revalidating === true);
  if (!access.data.feature_enabled || !access.data.program_access_enforced) return CLOSED;
  if (!Array.isArray(resources) || !resources.length || resources.some((resource) => !isEditorialResource(resource) || resource.status !== 'allowed')) return CLOSED;
  if (access.data.access_level === 'editor') return { canRead: true, canWrite: writeReady, readOnly: !writeReady };
  if (access.data.access_level === 'reviewer' && access.data.reviewer_write_enforced === true) return { canRead: true, canWrite: false, readOnly: true };
  return CLOSED;
}

export function getEditorialRouteAction(pathname) {
  if (/^\/(?:program\/(?:create|[^/]+\/book-import)(?:\/|$)|fixedlayout-editor\/[^/]+(?:\/|$))/.test(pathname)) return 'write';
  return 'read';
}
